export const getIconFromFileName = (filename) => {
    return filename
    .substr(filename.lastIndexOf('/') + 1)
    .replace('.svg', '')
    .replace('_', '-')
}
